import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Box from "@mui/material/Box"
import Checkbox from "@mui/material/Checkbox"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import { ISOWTemplate } from "pages/Projects/ProjectServices"

import { faCircle as faCircleLight } from "@fortawesome/pro-light-svg-icons"
import { faCircleCheck, faCircleInfo } from "@fortawesome/pro-solid-svg-icons"

type Props = {
    data: ISOWTemplate
    onChange: (id: number, checked: boolean) => void
    checked: boolean
    /** SB-7554: a project on a Production Planning template keeps it; the backend refuses with 409. */
    disabled?: boolean
    disabledReason?: string
}

const TemplateCard = (props: Props) => {
    const handleCardClick = () => {
        if (props.disabled) return
        props.onChange(props.data.template_id, !props.checked)
    }

    const card = (
        <Box
            padding={"8px"}
            aria-disabled={props.disabled || undefined}
            border={"0.5px solid #00000066"}
            borderRadius={"8px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"8px"}
            onClick={handleCardClick}
            sx={{ cursor: props.disabled ? "not-allowed" : "pointer", opacity: props.disabled ? 0.5 : 1 }}>
            <Checkbox
                sx={{
                    padding: "0px",
                }}
                icon={<FontAwesomeIcon icon={faCircleLight} color="#101941" />}
                checkedIcon={<FontAwesomeIcon icon={faCircleCheck} color="#101941" />}
                checked={props.checked}
                disabled={props.disabled}
            />
            <Box flex={1}>
                <Typography fontSize={"12px"} variant="subtitle2" fontWeight={500}>
                    {props.data.template_name}
                </Typography>
                <Typography variant="subtitle2" fontWeight={500} fontSize={"10px"} color="#10194199">
                    Scope: {props.data.scope.map(i => i.sow_name).join(", ")}
                </Typography>
            </Box>
            <Tooltip title={props.data.description}>
                <FontAwesomeIcon icon={faCircleInfo} color="#A8A8A8" />
            </Tooltip>
        </Box>
    )

    return props.disabled && props.disabledReason ? (
        <Tooltip title={props.disabledReason}>
            <span>{card}</span>
        </Tooltip>
    ) : (
        card
    )
}

export default TemplateCard
